import { AchPayment } from "./ach-payment.interface";
import { Address } from "./address.interface";
import { CreditCard } from "./credit-card.interface";

export class PaymentInfoModel {
  id?: string;
  creditCard?: CreditCard;
  address: Address;
  achPayment?: AchPayment;
  accountType?: string; // 'ECHK' stands for ACH payment, for card  - computed string as 'VISA' or 'MASTERCARD'
  allowAutomaticPayments?: boolean;

  constructor(model?: Partial<PaymentInfoModel>) {
    if (model) {
      Object.assign(this, model);
    } else {
      Object.assign(this, {
        creditCard: {
          account: undefined,
          expiry: undefined,
          name: undefined,
        },
        address: {
          address: undefined,
          city: undefined,
          state: undefined,
          country: undefined,
          postalCode: undefined,
        },
        achPayment: {
          account: undefined,
          name: undefined,
        },
        allowAutomaticPayments: false,
      });
    }
  }
}
